'use client';

// eslint-disable-next-line import/order
import { styled } from '@mui/material/styles';
// import ReactPlayer from 'react-player';

import dynamic from 'next/dynamic';

import type { FC } from 'react';
import type { ReactPlayerProps } from 'react-player';
const ReactPlayer = dynamic( async () => import( 'react-player' ), { ssr: false } );

export const CustomPlayer = styled( ReactPlayer )(() => ({
  width: '100% !important',
  height: '100% !important',
  '& video': { objectFit: 'cover' },
}));

/**
 * Player
 * @link https://github.com/CookPete/react-player
 */

export const Player: FC<ReactPlayerProps> = ({ ...other }) => <CustomPlayer {...other} />;

export default Player;
